import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Box from '@mui/material/Box';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import DonationForm from './components/forms/DonationForm';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import HowItWorks from './pages/HowItWorks';
import Reviews from './pages/Reviews';
import ScrollToTop from './components/ScrollToTop';
import FloatingDonateButton from './components/FloatingDonateButton';
import { theme } from './theme';
import { useEffect } from 'react';

const AppContent = () => {  

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100%',
      maxWidth: '100vw',
      margin: 0,
      padding: 0,
      overflow: 'hidden',
      overflowX: 'hidden'
    }}>
      <ScrollToTop />
      <Header />
      
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          width: '100%',
          margin: 0,
          padding: 0,
          overflow: 'hidden',
          overflowX: 'hidden'
        }}
      >
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/donate" element={<DonationForm />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/reviews" element={<Reviews />} />
        </Routes>
      </Box>

      <Footer />
      <FloatingDonateButton />
    </Box>
  );
};

const App = () => {
  useEffect(() => {
    // Add Zoho SalesIQ script
    const zohoScript = document.createElement('script');
    zohoScript.innerHTML = 'window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}';
    document.body.appendChild(zohoScript);

    const zsiqScript = document.createElement('script');
    zsiqScript.id = 'zsiqscript';
    zsiqScript.defer = true;
    zsiqScript.src = 'https://salesiq.zohopublic.com/widget?wc=siq151b0c747feb3c06cfe47c24df962c93';
    document.body.appendChild(zsiqScript);

    // Cleanup function
    return () => {
      document.body.removeChild(zohoScript);
      if (document.getElementById('zsiqscript')) {
        document.body.removeChild(zsiqScript);
      }
    };
  }, []); // Empty dependency array means this runs once when component mounts

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CssBaseline />
          <AppContent />
        </LocalizationProvider>
      </ThemeProvider>
    </Router>
  );
};

export default App;
